import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import MenusTab from '../components/outofstock/menustab';
import RecipesTab from '../components/outofstock/recipestab';
import OutOfStockTab from '../components/outofstock/outofstocktab';
import HistoryTab from '../components/outofstock/historytab';
import { useAuth } from '../auth/authcontext';

const { Title } = Typography;

const OutOfStock: React.FC = () => {
    const { userId } = useAuth();
    const reviewerGuid = userId || '';
    const [activeTab, setActiveTab] = useState('outofstock');

    const tabItems = [
        {
            key: 'outofstock',
            label: 'Out-of-Stock',
            children: <OutOfStockTab userGuid={reviewerGuid} activeTab={activeTab} />,
        },
        {
            key: 'menus',
            label: 'Menus',
            children: <MenusTab userGuid={reviewerGuid} activeTab={activeTab} />,
        },
        {
            key: 'recipes',
            label: 'Recipes',
            children: <RecipesTab userGuid={reviewerGuid} activeTab={activeTab} />,
        },
        {
            key: 'history',
            label: 'History',
            children: <HistoryTab activeTab={activeTab} />,
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <Title level={2}>Manage Out of Stock Items</Title>
            <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />
        </div>
    );
};

export default OutOfStock;